import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-35b20da1"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "mb-4 mt-2 px-4 py-3 text-center heading" };
var _hoisted_2 = { class: "font-bold w-full uppercase" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'CalculatorDescription',
    props: {
        calculatorDescription: String,
    },
    setup: function (__props) {
        var props = __props;
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(__props.calculatorDescription), 1)
            ]));
        };
    }
});
